<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Lista kašnjenja - zbirno</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Sektor -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label">Sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="seletedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
// import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  getSecondsFromTicks,
  maskIfEquealsValue,
  shouldEmployeeBeAdded,
} from "../../_helpers/arrangers";
//import //   getDateFromTicks,
//   maskIfEquealsValue,
//   isWorkingDayFromDate,
//"../../_helpers/arrangers";

// const colors = [
//   "#363636",
//   "#046FDB",
//   "#F85252",
//   "#8B54E4",
//   "#F07B3B",
//   "#3ba272",
// ];

export default {
  name: "LateList",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      params: {
        data: [
          [
            "",
            "",
            "neopravdano",
            "neopravdano",
            "neopravdano",
            "opravdano",
            "opravdano",
            "opravdano",
          ],
          [
            "Ndx",
            "Ime i prezime",
            "< 10 min",
            "> 10 min",
            "Ektremno",
            "< 10 min",
            "> 10 min",
            "Ektremno",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "7%" },
          { column: 1, width: "20%" },
        ],
      },
      departments: [],
      seletedDepartment: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
  },
  methods: {
    tableCellClicked() {},
    resetUi() {
      this.params.data = [
        [
          "",
          "",
          "neopravdano",
          "neopravdano",
          "neopravdano",
          "opravdano",
          "opravdano",
          "opravdano",
        ],
        [
          "Ndx",
          "Ime i prezime",
          "< 10 min",
          "> 10 min",
          "Ektremno",
          "< 10 min",
          "> 10 min",
          "Ektremno",
        ],
      ];
      this.dailyLogs = [];
    },
    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);

      this.getDepartments();
    },
    getDepartments() {
      ReportService.GetAllDepartmentsOfMyCompanyHistoricallyByMonth(
        this.selectedMonth,
        this.selectedYear
      ).then((response) => {
        // reset ui
        console.log("departments data: ", response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
      });
    },
    arrangeSectors(data) {
      this.departments = [];
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    getData(departmentId, month, year) {
      console.log("getData");
      ReportService.GetDailyLogsByDepartmentIdAndMonth(
        departmentId,
        month,
        year
      ).then((response) => {
        console.log(response.data);
        this.calculateData(response.data);
        this.pushData();
      });
    },
    calculateData(data) {
      // first add late array to employees
      this.employees.forEach((emp) => {
        emp.late = new Array(6).fill(0);
      });
      data.forEach((dlog) => {
        // who I belong to?
        let emplyoee = this.employees.find(
          (e) => e.employeeId === dlog.employeeId
        );
        // how much late?
        let late = getSecondsFromTicks(dlog.lateWorkhours);
        let isLateJustified = dlog.isLateJustified;
        console.log("late");
        console.log(late);
        if (late > 0 && !isLateJustified) {
          if (late < 600) {
            // les than 10 minutes
            // populate days
            emplyoee.late[0]++;
          } else if (late < 60 * 30) {
            emplyoee.late[1]++;
          } else {
            emplyoee.late[2]++;
          }
        } else if (late > 0 && isLateJustified) {
          if (late < 600) {
            // les than 10 minutes
            // populate days
            emplyoee.late[3]++;
          } else if (late < 60 * 30) {
            emplyoee.late[4]++;
          } else {
            emplyoee.late[5]++;
          }
        }
      });
    },
    pushData() {
      let ndx = 1;

      this.employees.forEach((emp) => {
        if (shouldEmployeeBeAdded(emp, this.selectedMonth, this.selectedYear)) {
          this.params.data.push([
            ndx++,
            emp.firstName + " " + emp.lastName,
            maskIfEquealsValue(emp.late[0], "0"),
            maskIfEquealsValue(emp.late[1], "0"),
            maskIfEquealsValue(emp.late[2], "0"),
            maskIfEquealsValue(emp.late[3], "0"),
            maskIfEquealsValue(emp.late[4], "0"),
            maskIfEquealsValue(emp.late[5], "0"),
          ]);
        }
      });
    },
    departmentSelected() {
      this.resetUi();

      let departmentId = this.seletedDepartment.id;

      this.employees = this.departmentData.find((d) => {
        return d.departmentId === departmentId;
      }).employee;

      this.getData(departmentId, this.selectedMonth, this.selectedYear);
    },
  },
};
</script>

<style scoped></style>
